export function keypressHandler(e: React.KeyboardEvent) {
  //13: Enter key, 32: Space key
  if (e.keyCode === 13 || e.keyCode === 32) {
    e.preventDefault();
    let target = e.target as HTMLElement;
    target.click();
  }
}
